import { render, staticRenderFns } from "./UserPhoto.vue?vue&type=template&id=778596c4&scoped=true"
import script from "./UserPhoto.vue?vue&type=script&lang=js"
export * from "./UserPhoto.vue?vue&type=script&lang=js"
import style0 from "./UserPhoto.vue?vue&type=style&index=0&id=778596c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778596c4",
  null
  
)

export default component.exports